import React, { useEffect, useRef } from 'react'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const FadeInRightEffect = ({
  children,
  tagName = 'div',
  className,
  ...props
}) => {
  const TagName = tagName
  const refFadeInRightEffect = useRef(null)

  useEffect(() => {
    if (window && document) {
      gsap.registerPlugin(ScrollTrigger)

      if (refFadeInRightEffect.current !== null) {
        window.setTimeout(() => {
          ScrollTrigger.create({
            trigger: refFadeInRightEffect.current,
            start: 'start 85%',
            end: 99999,
            onEnter: () => {
              refFadeInRightEffect.current?.classList.add('fade-in-right-active')
            },
            onLeaveBack: () => {
              refFadeInRightEffect.current?.classList.remove(
                'fade-in-right-active'
              )
            },
          })
        }, 400)
      }
    }
  }, [])

  return (
    <TagName
      ref={refFadeInRightEffect}
      className={className + ' fade-in-right'}
      {...props}
    >
      {children}
    </TagName>
  )
}

export default FadeInRightEffect
